import { createApp } from 'vue'
import App from './App.vue'
import './assets/scss/main.scss'

createApp(App).mount('#app')
